import * as React from 'react';
import useTranslator from './useTranslator';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DateTime(props) {
  const {
    format,
    children,
    ...extraProps
  } = props;
  const {
    formatDate
  } = useTranslator();
  return /*#__PURE__*/_jsx("time", {
    dateTime: formatDate(children, ''),
    title: formatDate(children, 'LLLL z'),
    ...extraProps,
    children: formatDate(children, format)
  });
}